import {
    GET_CALENDAR_ACTIVITIES,
    DELETE_CALENDAR_ACTIVITIE,
    CAL_LOADING,
    ADD_CALENDAR_ACTIVITIE,
    UPDATE_CALENDAR_ACTIVITIE,
    GET_CALENDAR_ACTIVITIES_BYID
} from "../actions/CalendarActions"

const initialState = {
    calendaractivities: [],
    calendaractivitie: [],
    loading: true,
    success: true,
    addCalendarItem: null
};

const CalendarReducer = function(state = initialState, action){
    switch (action.type) {
        case CAL_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_CALENDAR_ACTIVITIES: {
            return {
                ...state,
                calendaractivities: [...action.data],
                loading: false
            }
        }
        case GET_CALENDAR_ACTIVITIES_BYID: {
            return {
                ...state,
                calendaractivitie: [action.data],
                loading: false,
                success: true,
            }
        }
        case ADD_CALENDAR_ACTIVITIE: {
            return {
                ...state,
                addCalendarItem : action.data,
                success: true,
                loading: false
            }
        }
        case UPDATE_CALENDAR_ACTIVITIE: {
            return {
                ...state,
                addCalendarItem : action.data,
                success: true,
                loading: false
            }
        }
        case DELETE_CALENDAR_ACTIVITIE: {
            return {
                ...state,
                success: true,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default CalendarReducer;
  

